import React from 'react';
import { useTranslation } from 'react-i18next';

import CheckIcon from '@mui/icons-material/Check';

import AppButton from '../app-button/AppButton';
import { mergeSubscriptionButtonSx } from './subscriptionIconOnlyButtonSx';

type AppButtonProps = React.ComponentProps<typeof AppButton>;

export type AcceptSubscriptionRequestButtonProps = Omit<
  AppButtonProps,
  'children' | 'variant' | 'icon' | 'startIcon'
> & {
  iconOnly?: boolean;
};

export function AcceptSubscriptionRequestButton(
  props: AcceptSubscriptionRequestButtonProps,
) {
  const { loading, iconOnly, sx, ...rest } = props;
  const { t } = useTranslation();
  const label = t('common.accept');

  return (
    <AppButton
      {...rest}
      sx={mergeSubscriptionButtonSx(iconOnly, sx)}
      loading={loading}
      variant="contained"
      color="success"
      icon={<CheckIcon />}
      aria-label={iconOnly ? label : undefined}>
      {iconOnly ? null : label}
    </AppButton>
  );
}
